import { IoMdCloseCircle } from "react-icons/io";

const TagOptionsModal = ({ tag, onClose }) => {
  const options = tag?.options || [];

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50 p-3">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md max-h-[28rem] flex flex-col">
        <div className="flex justify-between items-center border-b px-4 py-3">
          <h2 className="text-lg font-semibold text-primary">
            Options for {tag?.tag_name}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800"
          >
            <IoMdCloseCircle size={24} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {options.length > 0 ? (
            options.map((option) => (
              <div
                key={option.id}
                className="flex items-center justify-between px-4 py-2 border-t"
              >
                <span>{option.tag_option_name}</span>
                <span className="text-sm text-gray-500">
                  {option.tag_option_id}
                </span>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm text-center mt-4">
              No options available.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TagOptionsModal;
